// extracted by mini-css-extract-plugin
module.exports = {"facebook":"#3b5998","google":"#4285f4","messenger":"#00baf7","playsome":"#00bfa5","spotify":"#1db954","telegram":"#34a9db","whatsapp":"#25cc64"};